<template>
  <div class="mobile-menu-blocker">
  </div><!-- .mobile-menu-blocker -->
</template>

<script>
const componentName = 'MobileMenuBlocker';

export default {
  name: componentName
}
</script>
